import React from "react";

// Class component — React error boundaries can only be implemented as
// classes (getDerivedStateFromError / componentDidCatch have no hook
// equivalent as of this writing).
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorId: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const errorId = Date.now().toString(36);

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/log/error`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        error_id: errorId,
        message: error.message,
        stack: error.stack?.substring(0, 1000),
        component_stack: info.componentStack?.substring(0, 500),
        url: window.location.href,
        timestamp: new Date().toISOString(),
      }),
    }).catch(() => {}); // fail silently — never let logging crash the app

    this.setState({ errorId });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            flexDirection: "column",
            gap: 16,
            fontFamily: "Inter, sans-serif",
            background: "#f5f4f0",
          }}
        >
          <div style={{ fontSize: 20, fontWeight: 700, color: "#1a1a18" }}>
            Gu<span style={{ color: "#1D9E75" }}>Mi</span>
          </div>
          <div style={{ fontSize: 16, fontWeight: 600, color: "#C53030" }}>
            GuMi hit a snag loading this page
          </div>
          <div
            style={{
              fontSize: 14,
              color: "#5f5e5a",
              textAlign: "center",
              maxWidth: 360,
            }}
          >
            We've logged this automatically. Try refreshing, that usually fixes it.
            Still stuck? Email{" "}
            <a href="mailto:support@gumiscore.com" style={{ color: "#C53030" }}>
              support@gumiscore.com
            </a>{" "}
            and we'll help directly.
          </div>
          <button
            onClick={() => { window.location.href = "/"; }}
            style={{
              background: "#1D9E75",
              color: "white",
              border: "none",
              borderRadius: 8,
              padding: "12px 24px",
              cursor: "pointer",
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            Back to GuMi
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
